import { BlogPost } from "@/features/BlogPost";
import { GetBlogPostSlugsQuery } from "@/generated";
import { GetBlogPostSlugsDocument } from "@/generated";
import { MainLayout } from "@/layouts/MainLayout";
import { ApolloClient, InMemoryCache } from "@apollo/client";
import { GetStaticPaths } from "next";
import { GetStaticProps } from "next";
import withData from "@/features/BlogPost/utils/withData";
import { useReadingTime } from "@/hooks/useReadingTime";
import { WithDataProps } from "@/features/BlogPost/types";

const BlogPostPage = (props: WithDataProps) => {
  const readingTime = useReadingTime("bg-eklight");

  return <BlogPost {...props} readingTime={readingTime} />;
};

BlogPostPage.getLayout = (page: React.ReactNode) => (
  <MainLayout noSpacing bgEkLight>
    {page}
  </MainLayout>
);

export const getStaticProps: GetStaticProps = async (context) => {
  try {
    return await withData()(context);
  } catch (error: any) {
    console.error("Error fetching blog post data:", error);
    return { props: {}, notFound: true };
  }
};

export const getStaticPaths: GetStaticPaths = async () => {
  const client = new ApolloClient({
    uri: `${process.env.NEXT_PUBLIC_API_URL}/graphql`,
    cache: new InMemoryCache(),
  });

  try {
    const { data } = await client.query<GetBlogPostSlugsQuery>({
      query: GetBlogPostSlugsDocument,
      variables: {
        pagination: { limit: 200 },
        filters: {
          slug: {
            notNull: true,
          },
        },
      },
    });

    const paths = (data?.blogPosts?.data
      ?.map((post) => ({
        params: {
          slug: [post.attributes?.slug],
        },
      }))
      .filter((post) => post.params.slug[0]) || []) as {
      params: { slug: string[] };
    }[];

    return { paths, fallback: "blocking" };
  } catch (error: any) {
    console.error("Error fetching blog post slugs:", error);
    return { paths: [], fallback: "blocking" };
  }
};

export default BlogPostPage;
